import React from 'react';
import type { QuoteFormData, QuoteFormErrors } from '../../types/quote';
import { CanadaAddressAutocomplete } from './CanadaAddressAutocomplete';
import { MuiTextInput } from './MuiInputs';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import PhoneIcon from '@mui/icons-material/Phone';

interface StepDeliveryDetailsProps {
  data: QuoteFormData;
  errors: QuoteFormErrors;
  onChange: (field: keyof QuoteFormData, value: any) => void;
}

export const StepDeliveryDetails: React.FC<StepDeliveryDetailsProps> = ({
  data,
  errors,
  onChange,
}) => {
  return (
    <div className="space-y-6">
      <div className="border-b border-gray-100 pb-4">
        <span className="text-xs uppercase tracking-widest text-[#F55109] font-bold">
          Step 3 of 6
        </span>
        <h3 className="text-2xl sm:text-3xl font-bold text-[#2C2C2C] special-header mt-1">
          SECTION 3 — DELIVERY DETAILS
        </h3>
        <p className="text-sm text-gray-500 mt-1">
          Where should Speedyssey deliver your items, and who should we contact at the destination?
        </p>
      </div>

      <div className="space-y-6">
        {/* Delivery Address with Canada Google Autocomplete (MUI) */}
        <CanadaAddressAutocomplete
          id="deliveryAddress"
          label="Delivery Address (Long Answer)"
          required
          rows={3}
          value={data.deliveryAddress}
          onChange={(address, details) => {
            onChange('deliveryAddress', address);
            if (details) {
              onChange('deliveryDetails', details);
            }
          }}
          error={errors.deliveryAddress}
          placeholder="Start typing Canadian destination address (e.g. 500 Bay St, Toronto, ON)..."
          helperText="Restricted to Canada. Select suggestion or add unit/suite/door details."
        />

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 pt-2">
          {/* Receiver Name */}
          <MuiTextInput
            id="receiverName"
            label="Receiver Name"
            value={data.receiverName}
            onChange={(val) => onChange('receiverName', val)}
            placeholder="Name of person receiving the delivery"
            required
            errorMessage={errors.receiverName}
            startIcon={<PersonOutlineIcon fontSize="small" />}
          />

          {/* Receiver Phone Number */}
          <MuiTextInput
            id="receiverPhoneNumber"
            label="Receiver Phone Number"
            type="tel"
            value={data.receiverPhoneNumber}
            onChange={(val) => onChange('receiverPhoneNumber', val)}
            placeholder="Phone number of receiver"
            required
            errorMessage={errors.receiverPhoneNumber}
            startIcon={<PhoneIcon fontSize="small" />}
          />
        </div>
      </div>
    </div>
  );
};
